import {
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    // FormGroup,
    FormLabel,
    Grid,
    // InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@material-ui/core";
import { EnumEspecialidadPrincipal, EnumTipoDoctor/*, EnumTipoEspecializacion*/ } from "../../../../settings/enumConfig";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import { DatePicker } from "@material-ui/pickers";
import { Fragment } from "react";
import InfoEmail from "./InfoEmail";
import InfoMaps from "./InfoMaps";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocInputPhone from "../../../utils/MeditocInputPhone";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocPassword from "../../../utils/MeditocPassword";
import MeditocSubtitulo from "../../../utils/MeditocSubtitulo";
import MeditocTab from "../../../utils/MeditocTab";
import MeditocTabs from "../../../utils/MeditocTabs";
// import { useCatalogo } from "../../../../context/CatalogoContext";
import { useColaborador } from "../../../../context/ColaboradorContext";

export default function FormColaborador() {
    // const { entCatalogos } = useCatalogo();

    const {
        listaEspecialidades,
        listaEspecialidadesCallCenter,
        colaboradorSeleccionado,
        modalOpenFormColaborador,
        formColaborador,
        formTabIndex,
        mostrarPassword,
        handleOpenFormColaborador,
        handleChangeInternoExterno,
        handleChangeFormColaboradorText,
        handleChangeFormColaboradorTextUpper,
        handleChangeFormColaboradorDate,
        handleChangeFormColaboradorCheck,
        handleChangeMostrarPassword,
        handleChangeTabIndex,
        handleSubmitFormColaborador,
    } = useColaborador();

    const {
        txtNombreDirectorio,
        txtCedulaDirectorio,
        txtRFCDirectorio,
        rdEspecialidad,
        txtTelefonoDirectorio,
        txtWhatsAppDirectorio,
        txtEmailDirectorio,
        slcEspecialidad,
        txtNombreConsultorio,
        txtDireccionConsultorio,
        txtUrlDirectorio,
        txtMapsDirectorio,
        txtNombreDoctor,
        txtApellidoPaternoDoctor,
        txtApellidoMaternoDoctor,
        dtpFechaNacimientoDoctor,
        txtTelefonoDoctor,
        txtEmailDoctor,
        txtDomicilioDoctor,
        txtUsuarioTitular,
        txtPasswordTitular,
        txtUsuarioAdmin,
        txtPasswordAdmin,
        chkAccesoDoctor,
        chkDoctorAdm,
    } = formColaborador;

    return (
        <MeditocModal
            open={modalOpenFormColaborador}
            setopen={handleOpenFormColaborador}
            okfunc={handleSubmitFormColaborador}
            okmessage="Guardar"
            size="normal"
            form
            title={
                colaboradorSeleccionado.iIdColaborador === 0
                    ? colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.CallCenter
                        ? "Nuevo Colaborador CallCenter"
                        : "Nuevo Colaborador Especialista"
                    : "Editar colaborador"
            }
        >
            <MeditocTabs
                tabs={["DATOS DEL DOCTOR", "DATOS DE CUENTA", "USUARIO Y CONTRASEÑA"]}
                index={formTabIndex}
                setIndex={handleChangeTabIndex}
            >
                <MeditocTab id={0} index={formTabIndex}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography variant="caption">
                                Los datos ingresados seran mostrados en el directorio de Médicos de Meditoc.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtNombreDirectorio"
                                label={txtNombreDirectorio.label}
                                required={txtNombreDirectorio.required}
                                value={txtNombreDirectorio.value}
                                error={txtNombreDirectorio.error}
                                helperText={txtNombreDirectorio.error && txtNombreDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                placeholder={txtNombreDirectorio.placeholder}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                autoFocus
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtCedulaDirectorio"
                                label={txtCedulaDirectorio.label}
                                required={txtCedulaDirectorio.required}
                                value={txtCedulaDirectorio.value}
                                error={txtCedulaDirectorio.error}
                                helperText={txtCedulaDirectorio.error && txtCedulaDirectorio.message}
                                onChange={handleChangeFormColaboradorTextUpper}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 8,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtRFCDirectorio"
                                label={txtRFCDirectorio.label}
                                required={txtRFCDirectorio.required}
                                value={txtRFCDirectorio.value}
                                error={txtRFCDirectorio.error}
                                helperText={txtRFCDirectorio.error && txtRFCDirectorio.message}
                                onChange={handleChangeFormColaboradorTextUpper}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 13,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtTelefonoDirectorio"
                                label={txtTelefonoDirectorio.label}
                                required={txtTelefonoDirectorio.required}
                                value={txtTelefonoDirectorio.value}
                                error={txtTelefonoDirectorio.error}
                                helperText={txtTelefonoDirectorio.error && txtTelefonoDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                InputProps={{
                                    inputComponent: MeditocInputPhone,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtWhatsAppDirectorio"
                                label={txtWhatsAppDirectorio.label}
                                required={txtWhatsAppDirectorio.required}
                                value={txtWhatsAppDirectorio.value}
                                error={txtWhatsAppDirectorio.error}
                                helperText={txtWhatsAppDirectorio.error && txtWhatsAppDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                InputProps={{
                                    inputComponent: MeditocInputPhone,
                                }}
                            />
                        </Grid>
                        {colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista ? (
                            <Grid item sm={6} xs={12}>
                                <FormControl componet="fieldset">
                                    <FormLabel component="legend">{rdEspecialidad.message}</FormLabel>
                                    <RadioGroup
                                        row
                                        name="rdEspecialidad"
                                        value={rdEspecialidad.value}
                                        onChange={handleChangeInternoExterno}
                                    >
                                        <FormControlLabel key={1} value="1" control={<Radio />} label="Interno" />
                                        <FormControlLabel key={2} value="2" control={<Radio />} label="Externo" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        ) : null}
                        {colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista ? (
                            <Grid item sm={6} xs={12}>
                                <TextField
                                    name="slcEspecialidad"
                                    label={slcEspecialidad.label}
                                    required={slcEspecialidad.required}
                                    value={slcEspecialidad.value}
                                    error={slcEspecialidad.error}
                                    helperText={slcEspecialidad.error && slcEspecialidad.message}
                                    onChange={handleChangeFormColaboradorText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    select
                                    SelectProps={{
                                        MenuProps: { PaperProps: { style: { maxHeight: 300 } } },
                                    }}
                                >
                                    {listaEspecialidades
                                        .filter((x) => x.iIdEspecialidad !== EnumEspecialidadPrincipal.MedicinaGeneral)
                                        .sort((a, b) => (a.sNombre > b.sNombre ? 1 : -1))
                                        .map((especialidad) => (
                                            <MenuItem
                                                key={especialidad.iIdEspecialidad}
                                                value={especialidad.iIdEspecialidad}
                                            >
                                                {especialidad.sNombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                        ) : null}
                        {colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.CallCenter ? (
                            <Grid item sm={6} xs={12}>
                                <TextField
                                    name="slcEspecialidad"
                                    label={slcEspecialidad.label}
                                    required={slcEspecialidad.required}
                                    value={slcEspecialidad.value}
                                    error={slcEspecialidad.error}
                                    helperText={slcEspecialidad.error && slcEspecialidad.message}
                                    onChange={handleChangeFormColaboradorText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    select
                                    SelectProps={{
                                        MenuProps: { PaperProps: { style: { maxHeight: 300 } } },
                                    }}
                                >
                                    {listaEspecialidadesCallCenter
                                        .sort((a, b) => (a.sNombre > b.sNombre ? 1 : -1))
                                        .map((especialidad) => (
                                            <MenuItem
                                                key={especialidad.iIdEspecialidad}
                                                value={especialidad.iIdEspecialidad}
                                            >
                                                {especialidad.sNombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                        ) : null}
                        <Grid
                            item
                            sm={colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.CallCenter ? 6 : 12}
                            xs={12}
                        >
                            <TextField
                                name="txtEmailDirectorio"
                                label={txtEmailDirectorio.label}
                                required={txtEmailDirectorio.required}
                                value={txtEmailDirectorio.value}
                                error={txtEmailDirectorio.error}
                                helperText={txtEmailDirectorio.error && txtEmailDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtDireccionConsultorio"
                                label={txtDireccionConsultorio.label}
                                required={txtDireccionConsultorio.required}
                                value={txtDireccionConsultorio.value}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtNombreConsultorio"
                                label={txtNombreConsultorio.label}
                                required={txtNombreConsultorio.required}
                                value={txtNombreConsultorio.value}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtUrlDirectorio"
                                label={txtUrlDirectorio.label}
                                required={txtUrlDirectorio.required}
                                value={txtUrlDirectorio.value}
                                helperText={txtUrlDirectorio.error && txtUrlDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtMapsDirectorio"
                                label={txtMapsDirectorio.label}
                                required={txtMapsDirectorio.required}
                                value={txtMapsDirectorio.value}
                                placeholder={txtMapsDirectorio.placeholder}
                                helperText={txtMapsDirectorio.error && txtMapsDirectorio.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                InputProps={{ endAdornment: <InfoMaps /> }}
                            />
                        </Grid>
                    </Grid>
                </MeditocTab>
                <MeditocTab id={1} index={formTabIndex}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                name="txtNombreDoctor"
                                label={txtNombreDoctor.label}
                                required={txtNombreDoctor.required}
                                value={txtNombreDoctor.value}
                                error={txtNombreDoctor.error}
                                helperText={txtNombreDoctor.error && txtNombreDoctor.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtApellidoPaternoDoctor"
                                label={txtApellidoPaternoDoctor.label}
                                required={txtApellidoPaternoDoctor.required}
                                value={txtApellidoPaternoDoctor.value}
                                error={txtApellidoPaternoDoctor.error}
                                helperText={txtApellidoPaternoDoctor.error && txtApellidoPaternoDoctor.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtApellidoMaternoDoctor"
                                label={txtApellidoMaternoDoctor.label}
                                required={txtApellidoMaternoDoctor.required}
                                value={txtApellidoMaternoDoctor.value}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                inputProps={{
                                    maxLength: 25,
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <DatePicker
                                name="dtpFechaNacimientoDoctor"
                                label={dtpFechaNacimientoDoctor.label}
                                required={dtpFechaNacimientoDoctor.required}
                                value={dtpFechaNacimientoDoctor.value}
                                error={dtpFechaNacimientoDoctor.error}
                                helperText={dtpFechaNacimientoDoctor.error && dtpFechaNacimientoDoctor.message}
                                onChange={(date) => handleChangeFormColaboradorDate(date, "dtpFechaNacimientoDoctor")}
                                InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                views={["year", "month", "date"]}
                                inputVariant={inputVariant}
                                format="dd/MM/yyyy"
                                color={inputColor}
                                variant="inline"
                                openTo="year"
                                fullWidth
                                autoOk={true}
                                maxDate={new Date().setFullYear(new Date().getFullYear() - 18)}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtTelefonoDoctor"
                                label={txtTelefonoDoctor.label}
                                required={txtTelefonoDoctor.required}
                                value={txtTelefonoDoctor.value}
                                error={txtTelefonoDoctor.error}
                                helperText={txtTelefonoDoctor.error && txtTelefonoDoctor.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                InputProps={{ inputComponent: MeditocInputPhone }}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtEmailDoctor"
                                label={txtEmailDoctor.label}
                                required={txtEmailDoctor.required}
                                value={txtEmailDoctor.value}
                                error={txtEmailDoctor.error}
                                helperText={txtEmailDoctor.error && txtEmailDoctor.message}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                InputProps={{ endAdornment: <InfoEmail /> }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                name="txtDomicilioDoctor"
                                label={txtDomicilioDoctor.label}
                                required={txtDomicilioDoctor.required}
                                value={txtDomicilioDoctor.value}
                                onChange={handleChangeFormColaboradorText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </MeditocTab>
                <MeditocTab id={2} index={formTabIndex}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className="center">
                            <FormControlLabel
                                label={chkAccesoDoctor.message}
                                control={
                                    <Checkbox
                                        checked={chkAccesoDoctor.value}
                                        onChange={(e) => handleChangeFormColaboradorCheck(e, "chkAccesoDoctor")}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Collapse in={chkAccesoDoctor.value}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <MeditocSubtitulo title="USUARIO TITULAR" />
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <TextField
                                            name="txtUsuarioTitular"
                                            label={txtUsuarioTitular.label}
                                            value={txtUsuarioTitular.value}
                                            error={txtUsuarioTitular.error}
                                            helperText={txtUsuarioTitular.error && txtUsuarioTitular.message}
                                            onChange={handleChangeFormColaboradorText}
                                            required={chkAccesoDoctor.value}
                                            autoComplete="new-password"
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            inputProps={{
                                                maxLength: 25,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <TextField
                                            name="txtPasswordTitular"
                                            label={txtPasswordTitular.label}
                                            value={txtPasswordTitular.value}
                                            onChange={handleChangeFormColaboradorText}
                                            type={mostrarPassword ? "text" : "password"}
                                            required={chkAccesoDoctor.value}
                                            autoComplete="new-password"
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            error={
                                                colaboradorSeleccionado.iIdColaborador === 0 && txtPasswordTitular.error
                                            }
                                            helperText={
                                                colaboradorSeleccionado.iIdColaborador === 0 &&
                                                txtPasswordTitular.error &&
                                                txtPasswordTitular.message
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <MeditocPassword
                                                        view={mostrarPassword}
                                                        setView={handleChangeMostrarPassword}
                                                    />
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    {colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista ? (
                                        <Fragment>
                                            <Grid item xs={12}>
                                                <MeditocSubtitulo title="USUARIO ADMINISTRATIVO" />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    name="txtUsuarioAdmin"
                                                    label={txtUsuarioAdmin.label}
                                                    value={txtUsuarioAdmin.value}
                                                    error={txtUsuarioAdmin.error}
                                                    helperText={txtUsuarioAdmin.error && txtUsuarioAdmin.message}
                                                    onChange={handleChangeFormColaboradorText}
                                                    required={chkAccesoDoctor.value}
                                                    autoComplete="new-password"
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 25,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <TextField
                                                    name="txtPasswordAdmin"
                                                    label={txtPasswordAdmin.label}
                                                    value={txtPasswordAdmin.value}
                                                    onChange={handleChangeFormColaboradorText}
                                                    type={mostrarPassword ? "text" : "password"}
                                                    required={chkAccesoDoctor.value}
                                                    autoComplete="new-password"
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    error={
                                                        colaboradorSeleccionado.iIdColaborador === 0 &&
                                                        txtPasswordAdmin.error
                                                    }
                                                    helperText={
                                                        colaboradorSeleccionado.iIdColaborador === 0 &&
                                                        txtPasswordAdmin.error &&
                                                        txtPasswordAdmin.message
                                                    }
                                                    InputProps={{
                                                        endAdornment: (
                                                            <MeditocPassword
                                                                view={mostrarPassword}
                                                                setView={handleChangeMostrarPassword}
                                                            />
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        </Fragment>
                                    ) : null}

                                    {colaboradorSeleccionado.iIdTipoDoctor !== EnumTipoDoctor.Especialista && (
                                        <Grid item xs={12} className="center">
                                            <FormControlLabel
                                                label={chkDoctorAdm.message}
                                                control={
                                                    <Checkbox
                                                        checked={chkDoctorAdm.value}
                                                        onChange={(e) =>
                                                            handleChangeFormColaboradorCheck(e, "chkDoctorAdm")
                                                        }
                                                    />
                                                }
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Collapse>
                        </Grid>
                    </Grid>
                </MeditocTab>
            </MeditocTabs>
        </MeditocModal>
    );
}
